import { AudioType } from '@colonist/audio';
import IconLargestArmyHighlight from '@static/images/icon_largest_army_highlight.svg';
import IconLongestRoadHighlight from '@static/images/icon_longest_road_highlight.svg';
import ImageMetropolisTrade from '@static/images/metropolis_trade.svg';
import ImageMetropolisScience from '@static/images/metropolis_science.svg';
import IconTradeHouse from '@static/images/icon_tradehouse.svg';
import IconAqueduct from '@static/images/icon_aqueduct.svg';
import IconFortress from '@static/images/icon_fortress.svg';
import ImageMetropolisPolitics from '@static/images/metropolis_politics.svg';
import { CITY_IMAGE_PATH } from '../../utils/gamePieces.ts';
export const GAME_ACHIEVEMENT_TYPES = [
    'LargestArmy',
    'LongestRoad',
    'MetropolisTrade',
    'MetropolisPolitics',
    'MetropolisScience',
    'TradingHouse',
    'Aqueduct',
    'Fortress'
];
export const getAchievementData = (achievementType, playerColor, context)=>{
    switch(achievementType){
        case 'LargestArmy':
            return {
                victoryPointChange: 2,
                title: {
                    key: 'strings:game.playerInformation.largestArmy.title'
                },
                soundType: AudioType.AchievementLargestArmy,
                icon: IconLargestArmyHighlight
            };
        case 'LongestRoad':
            return {
                victoryPointChange: 2,
                title: {
                    key: 'strings:game.playerInformation.longestRoad.title',
                    options: {
                        context: context
                    }
                },
                soundType: AudioType.AchievementLongestRoad,
                icon: IconLongestRoadHighlight
            };
        case 'MetropolisTrade':
            return {
                victoryPointChange: 2,
                title: {
                    key: 'strings:game.achievements.title.metropolis.Trade'
                },
                icon: CITY_IMAGE_PATH[playerColor],
                subIcon: ImageMetropolisTrade
            };
        case 'MetropolisPolitics':
            return {
                victoryPointChange: 2,
                title: {
                    key: 'strings:game.achievements.title.metropolis.Politics'
                },
                icon: CITY_IMAGE_PATH[playerColor],
                subIcon: ImageMetropolisPolitics
            };
        case 'MetropolisScience':
            return {
                victoryPointChange: 2,
                title: {
                    key: 'strings:game.achievements.title.metropolis.Science'
                },
                icon: CITY_IMAGE_PATH[playerColor],
                subIcon: ImageMetropolisScience
            };
        case 'TradingHouse':
            return {
                title: {
                    key: 'strings:game.achievements.title.tradingHouse'
                },
                subTitle: {
                    key: 'strings:game.achievements.bottomDescription.tradingHouse'
                },
                icon: IconTradeHouse
            };
        case 'Aqueduct':
            return {
                title: {
                    key: 'strings:game.achievements.title.aqueduct'
                },
                subTitle: {
                    key: 'strings:game.achievements.bottomDescription.aqueduct'
                },
                icon: IconAqueduct
            };
        case 'Fortress':
            return {
                title: {
                    key: 'strings:game.achievements.title.fortress'
                },
                subTitle: {
                    key: 'strings:game.achievements.bottomDescription.fortress'
                },
                icon: IconFortress
            };
    }
};
